export default __webpack_public_path__ + "static/budzisz-959e3ee5df246e230793e911d55b5639.jpg";